import { render } from "./hotQuesHome.vue?vue&type=template&id=5e106253&scoped=true"
import script from "./hotQuesHome.vue?vue&type=script&lang=js"
export * from "./hotQuesHome.vue?vue&type=script&lang=js"

import "./hotQuesHome.vue?vue&type=style&index=0&id=5e106253&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e106253"]])

export default __exports__